import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { useState, useEffect, createContext } from "react";
import Home from "./pages/Home";
import Inventory from "./pages/Inventory";
import Landing from "./pages/Landing";
import Goals from "./pages/Goals";
import Health from "./pages/Health";
import Recipe from "./pages/Recipe";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Exercisetracker from "./pages/Exercisetracker";

const Routers = () => {
  return (
    <BrowserRouter>
      <div className="flex flex-col min-h-screen overflow-hidden">
        <Header />

        {/*  Page content */}
        <main className="flex-grow">
          {/*  Page sections */}
          {/* <section className="relative"> */}
          <div className="max-w-6xl px-4 pt-10 mx-auto sm:px-6">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/landing" element={<Landing />} />
              <Route path="/goals" element={<Goals />} />
              <Route path="/health" element={<Health />} />
              <Route path="/recipe" element={<Recipe />} />
              <Route path="/exercisetracker" element={<Exercisetracker />} />
            </Routes>
          </div>
          {/* </section> */}
        </main>

        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default Routers;
